import { render, staticRenderFns } from "./PaymentRecordModal.vue?vue&type=template&id=60379e81&scoped=true"
import script from "./PaymentRecordModal.vue?vue&type=script&lang=ts"
export * from "./PaymentRecordModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60379e81",
  null
  
)

export default component.exports